namespace TabAurous.ProductDevelopment {
    export namespace CustomerRequirementService {
        export const baseUrl = 'ProductDevelopment/CustomerRequirement';

        export declare function Create(request: Serenity.SaveRequest<CustomerRequirementRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CustomerRequirementRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CustomerRequirementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<CustomerRequirementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/CustomerRequirement/Create",
            Update = "ProductDevelopment/CustomerRequirement/Update",
            Delete = "ProductDevelopment/CustomerRequirement/Delete",
            Retrieve = "ProductDevelopment/CustomerRequirement/Retrieve",
            List = "ProductDevelopment/CustomerRequirement/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CustomerRequirementService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
